import React, { useState, useEffect } from 'react';

import { BookOnlineContext } from '../context';
import { servicesData } from '../data/book-online';
import Layout from '../Layout';
import BookingForm from '../BookingForm';

const BookOnline = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [services, setServices] = useState([]);
  const [isBusiness, setIsBusiness] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);

  useEffect(() => {
    setServices(servicesData);
    let timer = setTimeout(() => setIsLoaded(true), 2000);
    return () => { clearTimeout(timer) }
  }, []);

  return (
    <BookOnlineContext.Provider value={{
        services,
        isBusiness,
        cartItems,
        cartTotal,
        setIsBusiness,
        setCartItems,
        setCartTotal
      }}
    >
      <Layout isLoaded={isLoaded}>
        <div className="BookOnline">
          <BookingForm />
        </div>
      </Layout>
    </BookOnlineContext.Provider>
  );
};

export default BookOnline;